import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TablePagination,
  Paper,
  Menu,
  Tooltip,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

import styles from "../utilities/cssmodules/Reports.module.css";
import {
  AttachFileRounded,
  EditRounded,
  EmailRounded,
  FormatListNumberedRounded,
  PersonRounded,
  WarningRounded,
} from "@mui/icons-material";

const BugReporting = () => {
  const navigate = useNavigate();

  //Go back to previous component
  const goBack = () => {
    navigate(-1);
  };

  const [inputs, setInputs] = useState({});
  const [file, setFile] = useState(null);

  /* handle the submission of the form */
  function handleSubmit(event) {
    event.preventDefault();
    alert("Bug report sent");

    // const requestData = {
    //   ...inputs,
    //   userId: userId,
    //   userEmail: userEmail,
    //   userFirstName: userFirstName,
    //   userLastName: userLastName
    // };

    // dispatch(sendBugReport(requestData))
    //     .then(() => {
    //         setInputs({}) //Clear inputs after submit
    //     })
  }

  /* update data in input fields as they are entered */
  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    setInputs((values) => ({
      ...values,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  return (
    <div className="component-wrapper">
      <div className="component-title">
        <div className="flex-row-container">
          <div className="flex-row-custom-1">
            <span className="title-back-button" onClick={goBack}>
              <Tooltip title="Go Back" arrow placement="top">
                <ArrowBackIosIcon />
              </Tooltip>
            </span>

            <span>Report Bug</span>
          </div>
        </div>
      </div>
      <div className="generic-activity-component-description">
        Hey there, help us improve our application by reporting any issues you
        encounter. Kindly fill out the form below and we'll resolve the issues
        and notify you.
      </div>

      <div className={styles.bug_report_wrapper}>
        <form
          className="generic-activity-component-form"
          onSubmit={handleSubmit}
        >
          <label htmlFor="bugreportdescription">
            <EditRounded /> Brief description
          </label>
          <section>
            <textarea
              name="bugdescription"
              placeholder="Provide a brief description of the bug"
              id="bugreportdescription"
              required
              value={inputs.bugdescription || ""}
              onChange={handleChange}
            />
          </section>

          <label htmlFor="bugreportdescription">
            <FormatListNumberedRounded /> Steps to reproduce bug
          </label>
          <section>
            <textarea
              name="bugsteps"
              placeholder="Describe the steps to reproduce the bug"
              id="bugreportdescription"
              required
              value={inputs.bugsteps || ""}
              onChange={handleChange}
            />
          </section>

          {/* Severity selection dropdown */}
          <label>
            <WarningRounded /> Severity
          </label>
          <section>
            <select
              name="bugseverity"
              value={inputs.bugseverity || ""}
              onChange={handleChange}
              required
            >
              <option value="" disabled>
                How severe is the bug?
              </option>
              <option value="Low">Low</option>
              <option value="Medium">Medium</option>
              <option value="High">High</option>
            </select>
          </section>

          {/* File upload */}
          <label>
            <AttachFileRounded /> Optional Attachment
          </label>
          <section>
            <input type="file"></input>
          </section>

          {/* If the submit button is disabled, add the "disabled" class to the button. If the button is enabled, then remove the disabled class from the button class */}
          {/* <button type="submit" className={`generic-submit-btn ${inputs.acceptTerms ? 'generic-submit-btn' : 'disabled'}`} disabled={!inputs.acceptTerms}>Submit</button> */}

          <button type="submit" className="generic-submit-btn">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default BugReporting;
